import styled from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScWinnersSection = styled.div`
  margin: 0;
`;

export const ScWinnersWrapp = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  .winner-box {
    .subtitle {
      text-transform: uppercase;
      margin-bottom: 24px;
      ${typography['headline3']}
    }
  }

  @media (${device.mobile}) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

export const ScNewWinners = styled.div`
  height: 312px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;
`;

export const ScPrimeWinners = styled.div`
  display: flex;
  padding: 24px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.grayDarkColor};
  flex-direction: column;
  row-gap: 16px;
  @media (${device.mobileXS}) {
    padding: 16px;
    row-gap: 12px;
  }
`;
